import entity from '../../../models/cms/menus'

export default [
  {
    path: '/menus',
    meta: {
      entity,
      requiresPermissionTo: 'menus',
      crud: 'list'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/menus/new',
    meta: {
      entity,
      requiresPermissionTo: 'menus',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/menus/:id',
    meta: {
      entity,
      requiresPermissionTo: 'menus',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  }
]
